import { Button, Card, Stack, Typography } from '@mui/material';
import { AddYourSchoolSvg, PlusIcon } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

export const SchoolFacilitiesEmptyCard: FC<{ isAdmin: boolean }> = ({ isAdmin }) => {
  const { formatMessage } = useIntl();

  return (
    <Card sx={{ backgroundColor: 'background.default', border: 'none', mb: 2.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" p={2}>
        <Stack gap={1}>
          <Typography variant="h2">
            {formatMessage({ id: 'timetable-RoomsSetup-Title' })}
          </Typography>
          <Typography variant="h3" color="text.primary">
            {formatMessage({
              id: isAdmin
                ? 'timetable-RoomsSetup-Description'
                : 'timetable-RoomsSetup-NoPermissionsDescription',
            })}
          </Typography>

          {isAdmin && (
            <Link to="/settings/facilities">
              <Button
                variant="outlined"
                startIcon={<PlusIcon />}
                sx={{ mt: 1, backgroundColor: 'background.paper' }}
              >
                {formatMessage({ id: 'timetable-RoomsSetup-AddCampusesAndRooms' })}
              </Button>
            </Link>
          )}
        </Stack>
        <img
          height={150}
          src={AddYourSchoolSvg}
          alt={formatMessage({ id: 'timetable-RoomsSetup-Title' })}
        />
      </Stack>
    </Card>
  );
};
